import {EMPTY_VALUES} from "../../../../Apis/functions";

/**
 * Author: Arnulfo Ferro Zapata
 * Job Title: Fullstack
 * Email: azpata@ibl.mx
 * Created At: 30 de 04 de 2026
 */

const SummaryItem = ({ label, value, t, className='',classNameValue=''}) => {

    return (
        <div className={`row w-100 background-shades-50 border-radius-8px p-12px gap-12px ${className}`}>
            <p className="font-color-general-950 ibl-font-w-600 fs-14px col-12 col-lg-5  p-0">
                {t(label)}
            </p>
            <p className={`font-color-shades-800 ibl-font-w-400 fs-14px col-12 col-lg-5 p-0 ${classNameValue}`}>
                {(value == null || value.trim?.() === '')
                    ? EMPTY_VALUES.DEFAULT
                    : value}
            </p>
        </div>
    );
}

export default SummaryItem
